import { Box } from '@mui/material';
import React, { useContext } from 'react';
import { Query } from '../../../definitions/query';
import { RoomViewContext } from './RoomViewContext';
import { stopEffects } from '../../../lib/Event';

type Props = React.PropsWithChildren<{
  queryParams?: Query;
  referrer: string;
}>;

const AnonymousIdentityGuard: React.FC<Props> = (props: Props): JSX.Element => {
  const { children, queryParams, referrer } = props;

  const { isAnonymousContact, verifyContactIdentity } =
    useContext(RoomViewContext);

  return (
    <>
      {React.Children.map(children, (child: any) => {
        if (!isAnonymousContact) {
          return child;
        }

        // wrap the children with a box that captures the click event, in
        // order to prompt the anonymous contact for their email
        if (!child?.props?.onClick) {
          return (
            <Box
              onClickCapture={stopEffects(() =>
                verifyContactIdentity(referrer, queryParams)
              )}
            >
              {child}
            </Box>
          );
        }

        return React.cloneElement(child, {
          onClick: () => verifyContactIdentity(referrer, queryParams),
        });
      })}
    </>
  );
};

export default AnonymousIdentityGuard;
